<script>
import { formatDateToPeriod } from '@/utils/date'

export default {
    props: {
        employeeImportFiles: Object,
        activeFile: String,
    },
    methods: {
        formatDateToPeriod,
        formatDate(date) {
            if (!date) {
                return ''
            }

            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            };

            const dateTime = new Date(date)
            return dateTime.toLocaleString({}, options)
        },
    },
}
</script>

<template>
    <div class="employee-imports-list">
        <div class="import-item-container">
            <ul
                class="import-item px-3 py-2 list-unstyled mb-0"
                :class="{active: employeeImportFile.uuid === activeFile}"
                v-for="employeeImportFile in employeeImportFiles.data"
                @click="() => $emit('file-selected', employeeImportFile.uuid)"
            >
                <li class="mb-0 ">
                    <span class="font-poppins mr-1">
                        {{ formatDate(employeeImportFile.created_at) }}
                    </span>
                    <span class="mr-1 float-right">
                        <i class="fas fa-chevron-right"></i>
                     </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="scss">
.employee-imports-list {
    border-right: 2px solid rgba(0, 0, 0, 0.125);
    height: 100%;
    .import-item-container {
        .import-item {
            color: #33658a;
            border-bottom: 2px solid rgba(0, 0, 0, 0.125);

            &.active, &:hover {
                font-weight: 600;
                cursor: pointer;
                background-color: #F5F9FE;
            }
        }
    }
}
</style>
